import {defineStore} from 'pinia'
import type {CurrentUser} from '@/domain/entity/CurrentUser'
import {reactive, ref, toRaw, computed} from 'vue'
import type {AppState} from '@/domain/entity/AppState'
import type {UserVertical} from '@/lib/services/UserProfileService'


export const useSession = defineStore('session',  () => {
  // init
  const userState = ref<CurrentUser>()
  const vertical = ref<UserVertical>()
  const appState = reactive<AppState>({})

  
  // ------------------------------- //
  //  Load App State Functionality   //
  // ------------------------------- //

  const loadAppState = async () => {
    // Clean minimal app state - listings managed via Retool iframe
    // No listing-specific state needed - using Retool iframe
  }

  
  // ------------------------------------------------- //
  //                                                   //
  //  User-related Getters and Actions                 //
  //                                                   //
  // ------------------------------------------------- //
  
  const fullName = computed(() => {
    if (!userState.value) return 'Guest'
    return `${userState.value.givenName} ${userState.value.familyName}`.trim()
  })

  const firstName = computed(() => { return userState.value?.givenName || 'User' })

  const profilePicture = computed(() => { return userState.value?.picture ?? '/img/defaults/user-default.jpg' })
  const email = computed(() => { return userState.value?.email ?? '' })
  const roles = computed(() => { return userState.value?.roles ?? [] })
  const userId = computed(() => { return userState.value?.id ?? '' })

  
  // ------------------------------- //
  //  User-related Actions           //
  // ------------------------------- //
  const setUser = (user: CurrentUser) => { userState.value = user }
  const setVertical = (value: UserVertical | undefined) => { vertical.value = value }

  // Removed setActiveListingType - listings managed via Retool iframe

  // Initialize app state
  loadAppState().then(() => 
    console.debug(`Loaded session.appState = ${JSON.stringify(toRaw(appState))}`)
  )


  // ------------------------------- //
  //  Return all needed properties   //
  // ------------------------------- //

  return {
    // State
    user: userState,
    vertical,
    app: appState,

    // Getters
    fullName,
    firstName,
    profilePicture,
    email,
    roles,
    userId,

    // Actions
    setUser,
    setVertical
  }
})
